import { Inject, Injectable } from 'ng-metadata/core';
import * as angular from 'angular';

/**
 * @ngdoc service
 * @name mwDateRangePickerDialogService
 * @module mw.components.dateRange
 * @description
 * A service that is used to open a date range picker in a modal
 */

 /**
  * @ngdoc method
  * @name mwDateRangePickerDialogService#show
  * @param {Object} dialogOptions - Object containing all the different types of display options
  * @param {Object} dateRangePickerOptions - Object containing options for the <mw-date-range-picker>
  *
  * @returns {Object} - A modified version of the display options based on your selections
  */
@Injectable('mwDateRangePickerDialogService')
export class DateRangePickerDialogService {
    displayOptions;

    constructor(
        @Inject('$mdDialog') private $mdDialog,
        @Inject('$translate') private $translate
    ) {}

    handleOk(dateRange) {
        this.$mdDialog.hide(dateRange);
    }

    handleCancel() {
        this.$mdDialog.cancel();
    }

    show(dialogOptions, dateRangePickerOptions) {
        return this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            controller: () => {
                'ngInject';
            },
            controllerAs: '$ctrl',
            locals: {
                handleCancel: this.handleCancel,
                handleOk: this.handleOk,
                $mdDialog: this.$mdDialog,
                dateRangePickerOptions: angular.copy(dateRangePickerOptions),
                selectedDateRange: undefined
            },
            multiple: true,
            parent: dialogOptions.parentElement,
            targetEvent: dialogOptions.targetEvent,
            template: `
                    <md-dialog class="mw-mini-modal mw-date-picker-modal mw-date-range-picker-modal" aria-label="Select Date Range" layout="column">
                        <mw-mini-modal-dialog
                            class="mw-mini-modal-dialog"
                            ok="{{'OK' | translate}}" cancel="{{'Cancel' | translate}}"
                            no-padding="true"
                            no-title-separator="true"
                            dialog-title="{{'mw-date-range-picker__dialog-title' | translate}}"
                            layout="column"
                            on-cancel="$ctrl.handleCancel()"
                            on-ok="$ctrl.handleOk($ctrl.selectedDateRange)"
                            is-ok-enabled="$ctrl.selectedDateRange !== undefined && $ctrl.selectedDateRange.endDate && $ctrl.selectedDateRange.endDate !== true">
                            <mw-modal-content>
                                <mw-date-range-picker
                                    min-view="$ctrl.dateRangePickerOptions.minView"
                                    max-view="$ctrl.dateRangePickerOptions.maxView"
                                    start-view="$ctrl.dateRangePickerOptions.startView"
                                    locale="$ctrl.dateRangePickerOptions.locale"
                                    timezone="$ctrl.dateRangePickerOptions.timezone"
                                    start-date="$ctrl.dateRangePickerOptions.startDate"
                                    end-date="$ctrl.dateRangePickerOptions.endDate"
                                    max-date="$ctrl.dateRangePickerOptions.maxDate"
                                    min-date="$ctrl.dateRangePickerOptions.minDate"
                                    max-days="$ctrl.dateRangePickerOptions.maxDays"
                                    validate="true"
                                    on-select="$ctrl.selectedDateRange = $event"
                                >
                                </mw-date-range-picker>
                            </mw-modal-content>
                        </mw-mini-modal-dialog>
                    </md-dialog>
                `
            });
        }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-range/date-range-picker/date-range-picker-dialog.service.ts